import { useContext } from 'react';

import EditAppoimentFormContext from './EditAppointmentFormContext';

const useEditAppointmentFormContext = () => useContext(EditAppoimentFormContext);

export default useEditAppointmentFormContext;